import React, { useState } from 'react';

export const FontTestPage = () => {
  const [testNumber, setTestNumber] = useState('88:88');
  const [testScore, setTestScore] = useState('88');

  const fontTests = [
    {
      name: 'DSEG7 Classic Light (Normal - sin ghost)',
      description: 'Solo segmentos activos, grosor delgado',
      style: { fontFamily: "'DSEG7 Classic', monospace", fontStyle: 'normal', fontWeight: 300 }
    },
    {
      name: 'DSEG7 Classic Light (Italic - CON ghost) ⭐',
      description: 'Segmentos fantasma visibles, grosor delgado - ESTILO CALCULADORA',
      style: { fontFamily: "'DSEG7 Classic', monospace", fontStyle: 'italic', fontWeight: 300 }
    },
    {
      name: 'DSEG7 Classic Regular (Normal - sin ghost)',
      description: 'Solo segmentos activos, grosor normal',
      style: { fontFamily: "'DSEG7 Classic', monospace", fontStyle: 'normal', fontWeight: 400 }
    },
    {
      name: 'DSEG7 Classic Regular (Italic - CON ghost) ⭐⭐',
      description: 'Segmentos fantasma visibles, grosor normal - RECOMENDADO',
      style: { fontFamily: "'DSEG7 Classic', monospace", fontStyle: 'italic', fontWeight: 400 }
    },
    {
      name: 'DSEG7 Classic Bold (Normal - sin ghost)',
      description: 'Solo segmentos activos, grosor grueso',
      style: { fontFamily: "'DSEG7 Classic', monospace", fontStyle: 'normal', fontWeight: 700 }
    },
    {
      name: 'DSEG7 Classic Bold (Italic - CON ghost) ⭐⭐⭐',
      description: 'Segmentos fantasma visibles, grosor grueso - MUY VISIBLE',
      style: { fontFamily: "'DSEG7 Classic', monospace", fontStyle: 'italic', fontWeight: 700 }
    },
  ];

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-4 text-center">Fuentes 7 Segmentos (Estilo Calculadora)</h1>
        <p className="text-center text-gray-400 mb-8">
          DSEG7 Classic - Las versiones <span className="text-amber-400 font-bold">Italic</span> muestran los segmentos apagados (ghost segments)
        </p>

        {/* Controls */}
        <div className="bg-gray-800 rounded-lg p-6 mb-8 border border-gray-700">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Tiempo de prueba</label>
              <input
                type="text"
                value={testNumber}
                onChange={(e) => setTestNumber(e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded text-white font-mono"
                placeholder="88:88"
              />
              <p className="text-xs text-gray-500 mt-1">Tip: Usa "88:88" para ver todos los segmentos</p>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Marcador de prueba</label>
              <input
                type="text"
                value={testScore}
                onChange={(e) => setTestScore(e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded text-white font-mono"
                placeholder="88"
              />
              <p className="text-xs text-gray-500 mt-1">Tip: Usa "88" para ver todos los segmentos</p>
            </div>
          </div>
        </div>

        {/* Font Test Grid */}
        <div className="space-y-6">
          {fontTests.map((test, index) => (
            <div key={index} className="bg-gray-800 rounded-lg p-6 border-2 border-gray-700 hover:border-amber-500 transition-colors">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-xl font-semibold text-amber-400">{test.name}</h3>
                  <p className="text-sm text-gray-400 mt-1">{test.description}</p>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Clock Display */}
                <div>
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-2 font-semibold">Reloj del partido</div>
                  <div className="relative bg-black rounded-lg p-8 border border-gray-700 shadow-[inset_0_4px_16px_rgba(0,0,0,0.9)]">
                    {/* Ghost layer */}
                    <div
                      style={{...test.style, fontStyle: 'normal'}}
                      className="text-8xl text-gray-800 leading-none tabular-nums"
                      aria-hidden="true"
                    >
                      88:88
                    </div>
                    {/* Active layer */}
                    <div
                      style={test.style}
                      className="absolute inset-0 p-8 text-8xl text-amber-400 shadow-[0_0_30px_rgba(251,191,36,0.6)] leading-none tabular-nums"
                    >
                      {testNumber}
                    </div>
                  </div>
                </div>

                {/* Score Display */}
                <div>
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-2 font-semibold">Marcador</div>
                  <div className="relative bg-black rounded-lg p-8 border border-gray-700 shadow-[inset_0_4px_16px_rgba(0,0,0,0.9)]">
                    {/* Ghost layer */}
                    <div
                      style={{...test.style, fontStyle: 'normal'}}
                      className="text-8xl text-gray-800 leading-none tabular-nums"
                      aria-hidden="true"
                    >
                      88
                    </div>
                    {/* Active layer */}
                    <div
                      style={test.style}
                      className="absolute inset-0 p-8 text-8xl text-green-400 shadow-[0_0_30px_rgba(74,222,128,0.6)] leading-none tabular-nums"
                    >
                      {testScore}
                    </div>
                  </div>
                </div>
              </div>

              {/* Font Details */}
              <div className="mt-4 p-4 bg-gray-900 rounded border border-gray-700">
                <div className="text-xs font-mono text-gray-400">
                  <div className="mb-1"><span className="text-blue-400">font-family:</span> {test.style.fontFamily}</div>
                  <div className="mb-1"><span className="text-blue-400">font-weight:</span> {test.style.fontWeight}</div>
                  <div><span className="text-blue-400">font-style:</span> {test.style.fontStyle}</div>
                </div>
              </div>

              {/* Copy button */}
              <button
                onClick={() => {
                  const css = `.seven-segment {\n  font-family: ${test.style.fontFamily};\n  font-weight: ${test.style.fontWeight};\n  font-style: ${test.style.fontStyle};\n}`;
                  navigator.clipboard.writeText(css);
                  alert('CSS copiado al portapapeles!');
                }}
                className="mt-3 w-full py-2 bg-blue-600 hover:bg-blue-700 rounded text-white font-medium text-sm"
              >
                📋 Copiar CSS
              </button>
            </div>
          ))}
        </div>

        {/* Key Features */}
        <div className="mt-8 bg-gradient-to-r from-blue-900/50 to-purple-900/50 border border-blue-700 rounded-lg p-6">
          <h3 className="text-lg font-bold mb-3 text-amber-400">Características del display tipo calculadora:</h3>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start gap-2">
              <span className="text-green-400 mt-1">✓</span>
              <span><strong>Segmentos fantasma:</strong> Las versiones <code className="bg-black/50 px-2 py-0.5 rounded text-amber-400">italic</code> muestran los segmentos apagados en gris (como una calculadora real)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-400 mt-1">✓</span>
              <span><strong>Esquinas angulosas:</strong> DSEG7 Classic tiene esquinas cuadradas/angulosas (no redondeadas)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-400 mt-1">✓</span>
              <span><strong>Gap entre segmentos:</strong> Los segmentos tienen separación visible entre ellos</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-400 mt-1">✓</span>
              <span><strong>Grosor variable:</strong> weight 300 (light), 400 (regular), 700 (bold)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-amber-400 mt-1">⭐</span>
              <span><strong>Recomendado:</strong> Regular Italic (peso 400) para mejor balance entre visibilidad y estética</span>
            </li>
          </ul>
        </div>

        {/* Font Loading Check */}
        <div className="mt-8 bg-gray-800 border border-gray-700 rounded-lg p-6">
          <h3 className="text-lg font-bold mb-4">Verificar carga de fuentes</h3>
          <button
            onClick={async () => {
              if (document.fonts) {
                await document.fonts.ready;
                const regular = document.fonts.check("16px 'DSEG7 Classic'");
                const italic = document.fonts.check("italic 16px 'DSEG7 Classic'");
                const bold = document.fonts.check("bold 16px 'DSEG7 Classic'");

                alert(
                  `Estado de fuentes DSEG7 Classic:\n\n` +
                  `✓ Regular: ${regular ? 'Cargada' : '✗ NO cargada'}\n` +
                  `✓ Italic (ghost): ${italic ? 'Cargada' : '✗ NO cargada'}\n` +
                  `✓ Bold: ${bold ? 'Cargada' : '✗ NO cargada'}\n\n` +
                  (regular && italic && bold ? '🎉 Todas las fuentes están cargadas correctamente!' : '⚠️ Algunas fuentes no se cargaron. Recarga la página.')
                );
              } else {
                alert('⚠️ La API de fuentes no está soportada en este navegador');
              }
            }}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded text-white font-medium"
          >
            🔍 Verificar estado de fuentes
          </button>
        </div>

        {/* Instructions */}
        <div className="mt-8 bg-amber-900/30 border border-amber-700 rounded-lg p-6">
          <h3 className="text-lg font-bold mb-3 text-amber-400">Cómo usar:</h3>
          <ol className="list-decimal list-inside space-y-2 text-sm">
            <li>Escribe "88:88" y "88" en los campos de arriba para ver TODOS los segmentos</li>
            <li>Las versiones con ⭐ son las que tienen segmentos fantasma (estilo calculadora)</li>
            <li>Busca la fuente donde veas los segmentos apagados en gris/transparente</li>
            <li>Haz clic en "Copiar CSS" para copiar la configuración que te guste</li>
            <li>Pega el CSS en tu archivo <code className="bg-black/50 px-2 py-0.5 rounded">index.css</code></li>
          </ol>
        </div>
      </div>
    </div>
  );
};
